<template>
  <AdminLayout v-model:activeTab="view" @toggle="handleToggle">
    <!-- Equipos -->
    <div v-if="view === 'maquinas'"><CrudMaquinas /></div>

    <!-- Mantenimiento -->
    <div v-if="view === 'actividades'"><CrudActividades /></div>
    <div v-if="view === 'refacciones'"><CrudRefacciones /></div>
    <div v-if="view === 'rutinas'"><CrudRutinas /></div>
    <div v-if="view === 'calendario'"><CalendarioMtto ref="calendarioRef" /></div>
    <div v-if="view === 'mtto_preventivo'"><EjecucionPreventivo /></div>
    <div v-if="view === 'mtto_correctivo'"><EjecucionCorrectivo /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";

// Equipos
import CrudMaquinas from "@/components/Maquinas/CrudMaquinas.vue";

// Mantenimiento
import CrudActividades from "@/components/Maquinas/CrudActividades.vue";
import CrudRefacciones from "@/components/Maquinas/CrudRefacciones.vue";
import CrudRutinas from "@/components/Maquinas/CrudRutinas.vue";
import CalendarioMtto from "@/components/Maquinas/Calendario/CalendarioMtto.vue";
import EjecucionPreventivo from "@/components/Maquinas/EjecucionPreventivo.vue";
import EjecucionCorrectivo from "@/components/Maquinas/EjecucionCorrectivo.vue";

const view = ref("maquinas");
const calendarioRef = ref(null);

function handleToggle() {
  // Notificar al calendario para que redibuje FullCalendar
  calendarioRef.value?.onSidebarToggle?.();
}
</script>
